/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Slider = __webpack_require__(1);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _KV = __webpack_require__(2);
	
	var _KV2 = _interopRequireDefault(_KV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
		new _KV2.default().init();
		new _Slider2.default('.slide1').init();
		new _Slider2.default('.slide2').init();
	
		$('.header a').click(function (e) {
			ga('send', 'pageview', '/201610/sp/index_btn.html');
			ga('officialTracker.send', 'pageview', '/201610/sp/index_btn.html');
		});
	
		$('.btns a').click(function (e) {
			var name = $(e.currentTarget).attr('class');
			if (name == 'location') {
				ga('send', 'pageview', '/201610/sp/location_btn.html');
				ga('officialTracker.send', 'pageview', '/201610/sp/location_btn.html');
			} else if (name == 'SP') {
				ga('send', 'pageview', '/201610/sp/other_btn.html');
				ga('officialTracker.send', 'pageview', '/201610/sp/other_btn.html');
			} else {
				var url = '/201610/sp/showroom_' + name + '_btn.html';
				ga('send', 'pageview', url);
				ga('officialTracker.send', 'pageview', url);
			}
		});
	
		$('.note').on('click', 'a.plus', function (e) {
			var isON = $(e.target).parent().toggleClass('ON').hasClass('ON');
			if (isON) ga('send', 'event', 'PS', 'open');else ga('send', 'event', 'PS', 'close');
		});
	
		var player;
		window.onYouTubeIframeAPIReady = function () {
			player = new YT.Player('ytplayer', {
				width: '100%',
				height: '100%',
				videoId: 'yc0BbxkcoIQ',
				playerVars: {
					'autoplay': 0,
					'controls': 1,
					'autohide': 1,
					'enablejsapi': 1,
					'loop': 0,
					'disablekb': 1,
					'fs': 0,
					'modestbranding': 0,
					'showinfo': 0,
					'rel': 0
				},
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});
		};
		function onPlayerReady(e) {
			ga('send', 'event', 'YouTube', 'ready');
		}
		function onPlayerStateChange(e) {
			var state = void 0;
			switch (e.data) {
				case -1:
					state = 'unstarted';break;
				case 0:
					state = 'ended';break;
				case 1:
					state = 'playing';
					ga('send', 'pageview', '/201610/sp/video_btn.html');
					ga('officialTracker.send', 'pageview', '/201610/sp/video_btn.html');
					break;
				case 2:
					state = 'paused';break;
				case 3:
					state = 'buffering';break;
				case 5:
					state = 'video cued';break;
			}
			if (!!state) ga('send', 'event', 'YouTube', 'state_change', state);else ga('send', 'event', 'YouTube', 'state_change', e.data);
		}
		if (YT.loaded) onYouTubeIframeAPIReady();
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	var Slider = (function () {
	    function Slider(e) {
	        this.$root = $(e);
	        this.$slider = this.$root.find('.slider');
	        this.$dots = this.$root.find('ul.dots a');
	    }
	    Slider.prototype.init = function () {
	        var _this = this;
	        this.$slider.slick({
	            arrows: false, dots: false,
	            infinite: true, autoplay: true,
	            speed: 500, autoplaySpeed: 4500
	        }).on('afterChange', function (e, slick, index) {
	            _this.$dots.removeClass('ON').eq(index).addClass('ON');
	        }).slick('slickGoTo', 0, false);
	        this.$dots.each(function (i, e) {
	            $(e).data('index', i);
	        }).click(function (e) {
	            var index = $(e.target).data('index');
	            _this.$slider.slick('slickGoTo', index);
	        });
	        return this;
	    };
	    return Slider;
	}());
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = Slider;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Slider_ts_1 = __webpack_require__(1);
	var KV = (function (_super) {
	    __extends(KV, _super);
	    function KV() {
	        _super.call(this, '.KV');
	    }
	    KV.prototype.init = function () {
	        var _this = this;
	        _super.prototype.init.call(this);
	        this.$slider.on('afterChange', function (e, slick, index) {
	            if (!index)
	                _this.$slider.slick('slickSetOption', 'autoplaySpeed', 3500);
	            else
	                _this.$slider.slick('slickSetOption', 'autoplaySpeed', 2500);
	        });
	        $(window).scroll(function (e) {
	            var ypos = $("html").scrollTop() || $("body").scrollTop(), isOFF = (ypos > 80);
	            _this.$root.toggleClass('OFF', isOFF);
	            if (isOFF)
	                _this.$slider.slick('slickPause');
	            else
	                _this.$slider.slick('slickPlay');
	        });
	        return this;
	    };
	    return KV;
	}(Slider_ts_1.default));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = KV;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** scripts/main.js
 **/